import { Component } from "react";
import Outdent from '../../../../../assets/images/module/general/Outdent.svg'

export class CustomOutdentBtn extends Component {
  render() {
    return (
      <div 
        className="rdw-option-wrapper outdent-custom-class" 
        onClick={this.props.onCustomOutdent}
        title="Ausrücken"
      >
        {/* <span style={{fontWeight: 'bold', fontSize: '18px'}}>⇤</span>  */}
        <img src={Outdent} alt="Outdent" style={{width: '16px', height: '14px'}} />
        {/* Replace the span with an icon like <FormatIndentDecreaseIcon /> if preferred */}
      </div>
    );
  }
}